import React, { useState } from 'react'

import List from '../../../components/List'

import { ROUTE_NAME, API_URL } from '../constants'
import { ROUTE_NAME as UserRouteName } from '../../../users/constants'

import styles from './List.module.css'

const UserList = () => {
  const [userId, setUserId] = useState(null)

  const userColumns = [
    {
      header: 'Name',
      value: (item) => `${item.firstName} ${item.lastName}`,
      onClick: (item) => setUserId(item.id),
    },
    { header: 'Username', value: (item) => item.username },
    { header: 'Buffers', value: (item) => item.buffers },
  ]

  const bufferColumns = [
    { header: 'Id', value: (item) => item.id },
    {
      header: 'User',
      value: (item) =>
        `${item.user.firstName} ${item.user.lastName} (${item.user.username})`,
      isLink: true,
    },
    { header: 'AI Layer', value: (item) => item.aiLayer.name },
    { header: 'Distance', value: (item) => item.distance },
    { header: 'Unit', value: (item) => item.unit },
  ]

  return (
    <div className={styles.row}>
      <div className={styles.column}>
        <List
          title="Users"
          routeName={UserRouteName}
          apiUrl={API_URL}
          columns={userColumns}
        />
      </div>
      <div className={styles.column}>
        {userId && (
          <List
            title="Buffers"
            routeName={ROUTE_NAME}
            apiUrl={`${API_URL}/byUser/${userId}`}
            columns={bufferColumns}
          />
        )}
      </div>
    </div>
  )
}

export default UserList
